import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=742f4b12&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
import style0 from "./Profile.scss?vue&type=style&index=0&id=742f4b12&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742f4b12",
  null
  
)

export default component.exports